<script setup lang="ts">
  import { useProjectStore } from '@/stores/project'
  import { storeToRefs } from 'pinia'

  const { currentItem } = storeToRefs(useProjectStore())
</script>
<template>
  <div class="drawer-header">
    <div class="header-font ml-4 mt-2 font-weight-medium elip">
      {{ currentItem.name }}
    </div>
    <div class="pl-4 d-flex align-center ga-3">
      <v-chip v-if="currentItem?.location" prepend-icon="mdi-map-marker" size="x-small" label>
        {{ currentItem.location }}
      </v-chip>
      <span class="client-font ellipsis">
        {{ currentItem.client }}
      </span>
    </div>
  </div>
</template>

<style scoped>
  .drawer-header {
    height: 74px;
  }
  .ellipsis {
    white-space: nowrap; /* Prevents text from wrapping */
    overflow: hidden; /* Hides overflowed text */
    text-overflow: ellipsis; /* Adds the ellipsis */
  }
</style>
